import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'constants/path';
import { CALENDLY_LINK } from 'constants/common';
import NeedHelp from 'components/NeedHelp';
import useCurrentUser from 'hooks/useCurrentUser';
import { ERoleCode } from 'types/enumItems';
import s from './s.module.less';

import illustration from './imgs/klarity-illustration.png';

const DISMISS_KEY = 'klarity_insurance_billing_banner_dismissed';

type Props = {
    onClose: () => void;
};

const AskChartBanner = ({ onClose }: Props) => {
    const navigate = useNavigate();
    // group 非 owner 成员无资格发起绑定，Get started 直接去 insurance-billing gate 页
    // （按 canView 展示 Landing / dashboard），不进 owner 向导。
    // currentUser 全局缓存挂载早期已拉好，点击时同步读，无闪跳；
    // solo（groupPractice=false）与 owner 照常进向导，canBind 权威判定由向导挂载守卫兜底
    const [currentUser] = useCurrentUser();
    const isGroupTeamMember = !!currentUser?.groupPractice && currentUser?.roleCode !== ERoleCode.GROUP_OWNER;
    const [dismissed, setDismissed] = useState(() => localStorage.getItem(DISMISS_KEY) === '1');
    const [showHelpDrawer, setShowHelpDrawer] = useState(false);

    const handleGetStarted = () => {
        if (isGroupTeamMember) {
            navigate(`${PATH.DASHBOARD}/${PATH.INSURANCE_BILLING}`);
            return;
        }
        navigate(PATH.INSURANCE_BILLING_ONBOARDING);
    };

    const handleClose = () => {
        localStorage.setItem(DISMISS_KEY, '1');
        setDismissed(true);
        onClose?.();
    };

    if (dismissed) return null;

    return (
        <>
            <div className={s.wrap}>
                <div className={s.left}>
                    <img src={illustration} alt="" className={s.illustration} />
                </div>
                <div className={s.center}>
                    <div className={s.title}>
                        <span className={s.emoji}>📋</span>
                        Cut your insurance billing costs in half with <span className={s.klarityText}>Klarity</span>
                    </div>
                    <div className={s.des}>
                        Klarity now does what a billing team does, without hiring one. It drafts claims, submits to
                        insurance, and handles denials at 3.9% per claim, about half what most billers charge. You only
                        pay when you get paid.
                    </div>
                </div>
                <div className={s.right}>
                    <span className={s.primaryBtn} onClick={handleGetStarted}>
                        Get started
                    </span>
                    <span className={s.secondaryBtn} onClick={() => setShowHelpDrawer(true)}>
                        Sign-up for Webinars
                    </span>
                    <span className={s.close} onClick={handleClose} role="button" aria-label="Close" tabIndex={0}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path
                                d="M1 13L13 1M1 1L13 13"
                                stroke="#4B5563"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </span>
                </div>
            </div>
            <NeedHelp
                show={showHelpDrawer}
                onClose={() => setShowHelpDrawer(false)}
                webinarLink={CALENDLY_LINK.KLARITY_BILLING_WEBINAR}
            />
        </>
    );
};

export default AskChartBanner;
